import { EmailConfigs } from "./types";

/**
 * Email Service Configuration
 *
 * Separate configurations for Quote and Contact forms:
 *
 * Quote Form Environment Variables:
 * - REACT_APP_QUOTE_EMAILJS_SERVICE_ID
 * - REACT_APP_QUOTE_EMAILJS_TEMPLATE_ID
 * - REACT_APP_QUOTE_EMAILJS_PUBLIC_KEY
 * - REACT_APP_QUOTE_RECIPIENT_EMAIL
 *
 * Contact Form Environment Variables:
 * - REACT_APP_CONTACT_EMAILJS_SERVICE_ID
 * - REACT_APP_CONTACT_EMAILJS_TEMPLATE_ID
 * - REACT_APP_CONTACT_EMAILJS_PUBLIC_KEY
 * - REACT_APP_CONTACT_RECIPIENT_EMAIL
 *
 * Add these to your .env file (see .env.example)
 */

export const emailConfigs: EmailConfigs = {
  quote: {
    serviceId:
      process.env.REACT_APP_QUOTE_EMAILJS_SERVICE_ID || "service_rcjfoa9",
    templateId:
      process.env.REACT_APP_QUOTE_EMAILJS_TEMPLATE_ID || "template_etogrqe",
    publicKey:
      process.env.REACT_APP_QUOTE_EMAILJS_PUBLIC_KEY || "_Cmr2VTvzWby0flSZ",
    recipientEmail:
      process.env.REACT_APP_QUOTE_RECIPIENT_EMAIL ||
      "sales.maasaryuagency@gmail.com",
  },
  contact: {
    serviceId:
      process.env.REACT_APP_CONTACT_EMAILJS_SERVICE_ID || "service_7y8ik5p",
    templateId:
      process.env.REACT_APP_CONTACT_EMAILJS_TEMPLATE_ID || "template_500bkmi",
    publicKey:
      process.env.REACT_APP_CONTACT_EMAILJS_PUBLIC_KEY || "_Cmr2VTvzWby0flSZ",
    recipientEmail:
      process.env.REACT_APP_CONTACT_RECIPIENT_EMAIL ||
      "info.maasaryuagency@gmail.com",
  },
};

// Validate configuration for a specific form type
export const validateEmailConfig = (type: "quote" | "contact"): boolean => {
  const config = emailConfigs[type];
  const { serviceId, templateId, publicKey, recipientEmail } = config;

  if (!serviceId || !templateId || !publicKey || !recipientEmail) {
    // eslint-disable-next-line no-console
    console.error(
      `EmailJS ${type} configuration is incomplete. Please check your environment variables.`
    );
    return false;
  }

  if (
    serviceId.includes("your_") ||
    templateId.includes("your_") ||
    publicKey.includes("your_")
  ) {
    // eslint-disable-next-line no-console
    console.error(
      `Please update EmailJS ${type} configuration with actual credentials.`
    );
    return false;
  }

  return true;
};

// Validate all configurations
export const validateAllEmailConfigs = (): boolean => {
  const quoteValid = validateEmailConfig("quote");
  const contactValid = validateEmailConfig("contact");
  return quoteValid && contactValid;
};

// Legacy support - use quote config by default
export const emailConfig = emailConfigs.quote;
